export const EXPENSE_GREATER_THAN_DEAL_ERROR =
  "Expense cannot be greater than the deal value.";

/**
 * Validates whether an expense exceeds the deal value.
 * Handles empty values, numeric conversions, string numbers with formatting (commas/spaces),
 * and decimal values correctly.
 *
 * @param {number|string|null|undefined} expense - The expense amount
 * @param {number|string|null|undefined} dealValue - The deal value/amount
 * @returns {{ isValid: boolean, error: string | null }}
 */
export function validateExpenseAgainstDeal(expense, dealValue) {
  const parseNumber = (val) => {
    if (val === null || val === undefined || val === "") return 0;
    if (typeof val === "number") return isNaN(val) ? 0 : val;
    const cleanStr = String(val).replace(/,/g, "").trim();
    if (cleanStr === "") return 0;
    const parsed = Number(cleanStr);
    return isNaN(parsed) ? 0 : parsed;
  };

  const parsedExpense = parseNumber(expense);
  const parsedDealValue = parseNumber(dealValue);

  // Validation Rule: expense > dealValue
  if (parsedExpense > parsedDealValue) {
    return {
      isValid: false,
      error: EXPENSE_GREATER_THAN_DEAL_ERROR,
    };
  }

  return {
    isValid: true,
    error: null,
  };
}
